import { Store } from 'redux';
import * as docActions from 'store/myDoctors/actions';
import * as authSelectors from 'store/authentication/selectors';
import * as actions from 'store/profile/actions';
import * as selectors from 'store/profile/selectors';

/**
 * Our profile fetching requirements to help make this straightforward
 * - Fetch on every login
 * - Fetch profile every hour while logged in
 *
 * Caveats: If user has no network access, user will be prompted
 * to restore network access before continuing to use the app
 *
 * Potential upgrades use InteractionManager to only run after
 * interactions once we determine if this blocks performance at all
 */

const ONE_HOUR = 1000 * 60 * 60;

let profilesInterval: NodeJS.Timeout;

export const refreshProfiles = (store: Store) => {
  if (profilesInterval) {
    clearInterval(profilesInterval);
  }

  profilesInterval = setInterval(() => {
    const state = store.getState();
    const profileLastUpdated = selectors.profileLastUpdatedSelector(state);
    const isAuthenticated = authSelectors.isDfdAuthenticatedSelector(state);

    if (!isAuthenticated) {
      return;
    }

    if (profileLastUpdated) {
      const diff = Date.now() - (profileLastUpdated + ONE_HOUR);

      if (diff > 0) {
        store.dispatch(actions.getProfile());
        store.dispatch(docActions.getMyDoctors());
      }
    }
  }, ONE_HOUR);
};
